var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.567,
    height: 128,
    viewBox: "0 0 115.567 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12644",
    "data-name": "Group 12644",
    transform: "translate(-1997.75 -8027.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M863.73,290.967h-8.695v-4.476a3.952,3.952,0,0,0-7.9,0v4.476H802.343v-4.476a3.951,3.951,0,0,0-7.9,0v4.476h-8.695a12.394,12.394,0,0,0-12.371,12.386v69.538a12.393,12.393,0,0,0,12.371,12.379H863.73A12.388,12.388,0,0,0,876.1,372.891V303.352A12.39,12.39,0,0,0,863.73,290.967Zm-82.452,33.2H868.2v48.729a4.483,4.483,0,0,1-4.469,4.476H785.746a4.483,4.483,0,0,1-4.469-4.476ZM798.4,309.406a3.949,3.949,0,0,0,3.948-3.948v-6.582h44.789v6.582a3.952,3.952,0,0,0,7.9,0v-6.582h8.695a4.483,4.483,0,0,1,4.469,4.476v12.907H781.278V303.352a4.483,4.483,0,0,1,4.469-4.476h8.695v6.582A3.955,3.955,0,0,0,798.4,309.406Z",
    transform: "translate(1230.795 7768.453)",
    fill: "#333",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    d: "M22.791-.75H91.276a23.531,23.531,0,0,1,23.541,23.467V90.983A23.531,23.531,0,0,1,91.276,114.45H22.791A23.531,23.531,0,0,1-.75,90.983V22.717A23.531,23.531,0,0,1,22.791-.75Zm68.484,102.4a10.7,10.7,0,0,0,10.7-10.667V22.717a10.7,10.7,0,0,0-10.7-10.667H22.791a10.7,10.7,0,0,0-10.7,10.667V90.983a10.7,10.7,0,0,0,10.7,10.667Z",
    transform: "translate(1998.5 8041.414)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M5.67,37.65a6.41,6.41,0,0,1-6.42-6.4V5.65a6.42,6.42,0,0,1,12.841,0v25.6A6.41,6.41,0,0,1,5.67,37.65Z",
    transform: "translate(2075.544 8028.613)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M5.67,37.65a6.41,6.41,0,0,1-6.42-6.4V5.65a6.42,6.42,0,0,1,12.841,0v25.6A6.41,6.41,0,0,1,5.67,37.65Z",
    transform: "translate(2024.182 8028.613)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_21",
    "data-name": "Line 21",
    d: "M108.4,12.05H5.67a6.4,6.4,0,1,1,0-12.8H108.4a6.4,6.4,0,1,1,0,12.8Z",
    transform: "translate(1998.5 8079.813)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    "data-name": "Line 22",
    d: "M5.67,31.25a6.41,6.41,0,0,1-6.42-6.4V5.65a6.42,6.42,0,0,1,12.841,0v19.2A6.41,6.41,0,0,1,5.67,31.25Z",
    transform: "translate(2049.863 8105.413)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.2ac70ba1a0f4cba93fe1299ec26ddd9c.svg";
export { ForwardRef as ReactComponent };